import { render, staticRenderFns } from "./newDetail.vue?vue&type=template&id=0f6f3386&"
import script from "./newDetail.vue?vue&type=script&lang=js&"
export * from "./newDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports